import "./index.css";
import { useContext } from "react";
import { NavContext } from "../../App";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useUserModules } from "../UserModuleContext";
import companyIcon from "../../assets/icons-tabs/company-icon.svg";
import productIcon from "../../assets/icons-tabs/wrench-icon.svg";
import ambitionIcon from "../../assets/icons-tabs/ambition-icon.svg";
import reportIcon from "../../assets/icons-tabs/report-icon.svg";
import mapIcon from "../../assets/icons-tabs/map-icon.svg";
import profileIcon from "../../assets/icons-tabs/profile_icon.svg";
import aboutIcon from "../../assets/icons-tabs/about-icon.svg";
import feedIcon from "../../assets/icons-tabs/feed-icon.svg";
import educationIcon from "../../assets/icons-tabs/education-icon.svg";
import clientIcon from "../../assets/icons-tabs/client-icon.svg";
import shareIcon from "../../assets/icons-tabs/share-icon.svg";
import locked from "../../assets/locked.svg";

const withAccessControl = (WrappedComponent) => {
  return ({ moduleName, ...props }) => {
    const { isModuleAccessible } = useUserModules();

    const isLocked = moduleName ? !isModuleAccessible(moduleName) : false;

    return <WrappedComponent {...props} isLocked={isLocked} />;
  };
};

export const NavigationStyle1 = withAccessControl(
  ({ setNav, text, style, selected, isLocked }) => {
    const dynamicStyles = selected
      ? {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "130px",
          height: "120px",
        }
      : {};

    const styleh4 = selected ? { top: "0" } : {};
    const lockedStyle = isLocked
      ? {
          position: "relative",
          pointerEvents: "none",
          opacity: 0.5,
        }
      : {};

    return (
      <div
        className={
          "navigation__label__style1" + (selected ? " __selected" : "")
        }
        style={{ ...style, ...dynamicStyles, ...lockedStyle }}
        onClick={setNav}
      >
        {selected && (
          <div style={{ marginBottom: "10px" }}>
            <img src={educationIcon} alt="Education Icon" />
          </div>
        )}
        <h4 style={{ ...styleh4 }}>{text}</h4>
        {isLocked && (
          <img
            src={locked}
            alt="Locked"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "16px",
              height: "24px",
              zIndex: 10,
            }}
          />
        )}
      </div>
    );
  }
);

export const NavigationStyle2 = withAccessControl(
  ({ setNav, text, style, selected, isLocked }) => {
    const dynamicStyles = selected
      ? {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "150px",
          height: "130px",
        }
      : {};

    const lockedStyle = isLocked
      ? {
          position: "relative",
          pointerEvents: "none",
          opacity: 0.5,
        }
      : {};

    return (
      <div
        className={
          "navigation__label__style2" + (selected ? " __selected" : "")
        }
        style={{ ...style, ...dynamicStyles, ...lockedStyle }}
        onClick={setNav}
      >
        {selected && (
          <div style={{ marginBottom: "14px" }}>
            <img src={productIcon} alt="Product Icon" />
          </div>
        )}
        <h4>{text}</h4>
        {isLocked && (
          <img
            src={locked}
            alt="Locked"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "16px",
              height: "24px",
              zIndex: 10,
            }}
          />
        )}
      </div>
    );
  }
);

export const NavigationStyle3 = withAccessControl(
  ({ setNav, text, style, selected, isLocked }) => {
    const dynamicStyles = selected
      ? {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "190px",
          height: "130px",
        }
      : {};

    const lockedStyle = isLocked
      ? {
          position: "relative",
          pointerEvents: "none",
          opacity: 0.5,
        }
      : {};

    return (
      <div
        className={
          "navigation__label__style3" + (selected ? " __selected" : "")
        }
        style={{ ...style, ...dynamicStyles, ...lockedStyle }}
        onClick={setNav}
      >
        {selected && (
          <div style={{ marginBottom: "14px" }}>
            <img src={companyIcon} alt="Company Icon" />
          </div>
        )}
        <h4>{text}</h4>
        {isLocked && (
          <img
            src={locked}
            alt="Locked"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "16px",
              height: "24px",
              zIndex: 10,
            }}
          />
        )}
      </div>
    );
  }
);

export const NavigationStyle4 = withAccessControl(
  ({ setNav, text, style, selected, isLocked }) => {
    const dynamicStyles = selected
      ? {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "180px",
          height: "130px",
        }
      : {};

    const lockedStyle = isLocked
      ? {
          position: "relative",
          pointerEvents: "none",
          opacity: 0.5,
        }
      : {};

    return (
      <div
        className={
          "navigation__label__style4" + (selected ? " __selected" : "")
        }
        style={{ ...style, ...dynamicStyles, ...lockedStyle }}
        onClick={setNav}
      >
        {selected && (
          <div style={{ marginBottom: "14px" }}>
            <img src={ambitionIcon} alt="Ambition Icon" />
          </div>
        )}
        <h4>{text}</h4>
        {isLocked && (
          <img
            src={locked}
            alt="Locked"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "16px",
              height: "24px",
              zIndex: 10,
            }}
          />
        )}
      </div>
    );
  }
);

export const NavigationStyle5 = withAccessControl(
  ({ setNav, text, style, selected, isLocked }) => {
    const dynamicStyles = selected
      ? {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "150px",
          height: "130px",
        }
      : {};

    const lockedStyle = isLocked
      ? {
          position: "relative",
          pointerEvents: "none",
          opacity: 0.5,
        }
      : {};

    return (
      <div
        className={
          "navigation__label__style5" + (selected ? " __selected" : "")
        }
        style={{ ...style, ...dynamicStyles, ...lockedStyle }}
        onClick={setNav}
      >
        {selected && (
          <div style={{ marginBottom: "14px" }}>
            <img src={reportIcon} alt="Report Icon" />
          </div>
        )}
        <h4>{text}</h4>
        {isLocked && (
          <img
            src={locked}
            alt="Locked"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "16px",
              height: "24px",
              zIndex: 10,
            }}
          />
        )}
      </div>
    );
  }
);

export const NavigationStyle6 = withAccessControl(
  ({ setNav, text, style, selected, isLocked }) => {
    const dynamicStyles = selected
      ? {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "173px",
        }
      : {};

    const styleh4 = selected ? { top: "0" } : {};
    const lockedStyle = isLocked
      ? {
          position: "relative",
          pointerEvents: "none",
          opacity: 0.5,
        }
      : {};

    return (
      <div
        className={
          "navigation__label__style6" + (selected ? " __selected" : "")
        }
        style={{ ...style, ...dynamicStyles, ...lockedStyle }}
        onClick={setNav}
      >
        <h4 style={{ ...styleh4 }}>{text}</h4>
        {isLocked && (
          <img
            src={locked}
            alt="Locked"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "16px",
              height: "24px",
              zIndex: 10,
            }}
          />
        )}
        {selected && (
          <div style={{ marginLeft: "20px" }}>
            <img src={feedIcon} alt="Feed Icon" />
          </div>
        )}
      </div>
    );
  }
);

export const NavigationStyle7 = withAccessControl(
  ({ setNav, text, style, selected, isLocked }) => {
    const dynamicStyles = selected
      ? {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "173px",
        }
      : {};

    const styleh4 = selected ? { top: "0" } : {};
    const lockedStyle = isLocked
      ? {
          position: "relative",
          pointerEvents: "none",
          opacity: 0.5,
        }
      : {};

    return (
      <div
        className={
          "navigation__label__style7" + (selected ? " __selected" : "")
        }
        style={{ ...style, ...dynamicStyles, ...lockedStyle }}
        onClick={setNav}
      >
        <h4 style={{ ...styleh4 }}>{text}</h4>
        {isLocked && (
          <img
            src={locked}
            alt="Locked"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "16px",
              height: "24px",
              zIndex: 10,
            }}
          />
        )}
        {selected && (
          <div style={{ marginLeft: "20px" }}>
            <img src={profileIcon} alt="Profile Icon" />
          </div>
        )}
      </div>
    );
  }
);

export const NavigationStyle8 = withAccessControl(
  ({ setNav, text, style, selected, isLocked }) => {
    const dynamicStyles = selected
      ? {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "173px",
        }
      : {};

    const styleh4 = selected ? { top: "0" } : {};
    const lockedStyle = isLocked
      ? {
          position: "relative",
          pointerEvents: "none",
          opacity: 0.5,
        }
      : {};

    return (
      <div
        className={
          "navigation__label__style8" + (selected ? " __selected" : "")
        }
        style={{ ...style, ...dynamicStyles, ...lockedStyle }}
        onClick={setNav}
      >
        <h4 style={{ ...styleh4 }}>{text}</h4>
        {isLocked && (
          <img
            src={locked}
            alt="Locked"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "16px",
              height: "24px",
              zIndex: 10,
            }}
          />
        )}
        {selected && (
          <div style={{ marginLeft: "20px" }}>
            <img src={aboutIcon} alt="About Us Icon" />
          </div>
        )}
      </div>
    );
  }
);

export const NavigationStyle11 = withAccessControl(
  ({ setNav, text, style, selected, isLocked }) => {
    const dynamicStyles = selected
      ? {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "150px",
          height: "130px",
        }
      : {};

    const lockedStyle = isLocked
      ? {
          position: "relative",
          pointerEvents: "none",
          opacity: 0.5,
        }
      : {};

    return (
      <div
        className={
          "navigation__label__style11" + (selected ? " __selected" : "")
        }
        style={{ ...style, ...dynamicStyles, ...lockedStyle }}
        onClick={setNav}
      >
        {selected && (
          <div style={{ marginBottom: "14px" }}>
            <img src={mapIcon} alt="Map Icon" />
          </div>
        )}
        <h4>{text}</h4>
        {isLocked && (
          <img
            src={locked}
            alt="Locked"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "16px",
              height: "24px",
              zIndex: 10,
            }}
          />
        )}
      </div>
    );
  }
);

export const NavigationStyle12 = withAccessControl(
  ({ setNav, text, style, selected, isLocked }) => {
    const dynamicStyles = selected
      ? {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "150px",
          height: "130px",
        }
      : {};

    const lockedStyle = isLocked
      ? {
          position: "relative",
          pointerEvents: "none",
          opacity: 0.5,
        }
      : {};

    return (
      <div
        className={
          "navigation__label__style12" + (selected ? " __selected" : "")
        }
        style={{ ...style, ...dynamicStyles, ...lockedStyle }}
        onClick={setNav}
      >
        {selected && (
          <div style={{ marginBottom: "14px" }}>
            <img src={clientIcon} alt="Client Icon" />
          </div>
        )}
        <h4>{text}</h4>
        {isLocked && (
          <img
            src={locked}
            alt="Locked"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "16px",
              height: "24px",
              zIndex: 10,
            }}
          />
        )}
      </div>
    );
  }
);

export const NavigationStyle13 = withAccessControl(
  ({ setNav, text, style, selected, isLocked }) => {
    const dynamicStyles = selected
      ? {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "150px",
          height: "130px",
        }
      : {};

    const lockedStyle = isLocked
      ? {
          position: "relative",
          pointerEvents: "none",
          opacity: 0.5,
        }
      : {};

    return (
      <div
        className={
          "navigation__label__style13" + (selected ? " __selected" : "")
        }
        style={{ ...style, ...dynamicStyles, ...lockedStyle }}
        onClick={setNav}
      >
        {selected && (
          <div style={{ marginBottom: "14px" }}>
            <img src={shareIcon} alt="Share Icon" />
          </div>
        )}
        <h4>{text}</h4>
        {isLocked && (
          <img
            src={locked}
            alt="Locked"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "16px",
              height: "24px",
              zIndex: 10,
            }}
          />
        )}
      </div>
    );
  }
);

const Navigation = () => {
  const [, setNav] = useContext(NavContext);
  const { t } = useTranslation();
  const { isModuleAccessible } = useUserModules();

  const handleNav = (number) => {
    setNav(number);
    window.scrollTo(0, 0);
    document.getElementsByTagName("body")[0].className = "";
  };

  const pathname = window.location.pathname;

  const createImgIcon =
    (src, alt) =>
    ({ className }) =>
      <img src={src} alt={alt} className={className} />;

  const pageTabs = [
    {
      label: "Company",
      text: t("COMPANY"),
      moduleName: "Company",
      to: "/company",
      navId: 3,
      icon: createImgIcon(companyIcon, "Company"),
      isActive: pathname.startsWith("/company"),
    },
    {
      label: "Product",
      text: t("PRODUCT"),
      moduleName: "Product",
      to: "/product",
      navId: 2,
      icon: createImgIcon(productIcon, "Product"),
      isActive: pathname.startsWith("/product") || pathname.startsWith("/service"),
    },
    {
      label: "Client",
      text: t("CLIENT"),
      moduleName: "Client",
      to: "/client",
      navId: 12,
      icon: createImgIcon(clientIcon, "Client"),
      isActive: pathname.startsWith("/client"),
    },
    {
      label: "Ambition",
      text: t("AMBITION"),
      moduleName: "Ambition",
      to: "/ambition",
      navId: 4,
      icon: createImgIcon(ambitionIcon, "Ambition"),
      isActive: pathname.startsWith("/ambition"),
    },
    {
      label: "Report",
      text: t("REPORT"),
      moduleName: "Report",
      to: "/reporting",
      navId: 5,
      icon: createImgIcon(reportIcon, "Report"),
      isActive: pathname.startsWith("/reporting"),
    },
    {
      label: "Share",
      text: t("SHARE_TAB"),
      moduleName: "Share",
      to: "/share",
      navId: 13,
      icon: createImgIcon(shareIcon, "Share"),
      isActive: pathname.startsWith("/share"),
    },
    {
      label: "Map",
      text: "Map",
      moduleName: "Map",
      to: "/waste-map",
      navId: 11,
      icon: createImgIcon(mapIcon, "Map"),
      isActive: pathname.startsWith("/waste-map"),
    },
  ];

  return (
    <>
      <div className="company__navigation d-flex position-sticky justify-content-between">
        <div
          className="company__navigation__left d-flex"
          style={{ justifyContent: "space-between", width: "100%" }}
        >
          <nav className="flex items-center gap-1 flex-wrap justify-center company__pageTabs">
            {pageTabs.map(
              ({ label, text, icon: Icon, isActive, to, moduleName, navId }) => {
                const active = isActive;
                const locked = moduleName ? !isModuleAccessible(moduleName) : false;

                const className = `inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm transition border ${
                  active
                    ? "bg-primary text-primary-foreground border-primary"
                    : "bg-surface-muted text-muted-foreground border-transparent hover:text-foreground hover:border-border/70"
                } ${locked ? "pointer-events-none opacity-50" : ""}`;

                return (
                  <Link
                    key={label}
                    to={to}
                    className={className}
                    onClick={() => handleNav(navId)}
                  >
                    <Icon className="h-3.5 w-3.5" />
                    {text}
                  </Link>
                );
              }
            )}
          </nav>
        </div>
      </div>
    </>
  );
};

export default Navigation;
